import { render, staticRenderFns } from "./VaSelect.vue?vue&type=template&id=bd846964&"
import script from "./VaSelect.vue?vue&type=script&lang=js&"
export * from "./VaSelect.vue?vue&type=script&lang=js&"
import style0 from "./VaSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports